// Copyright (c) 2019 Deere & Company
import moment from 'moment';
import React from 'react';

const cellRenderer = params => (
    <a name="claimNumber" data-warrantyClaimId={params.data.warrantyClaimId}>
        {params.data.claimNumber}
    </a>
);

const ShortClaimTableColumnDefinitions = [
    // {
    //     checkboxSelection: true,
    //     width: 75,
    // },

    {
        field: 'claimNumber',
        headerName: 'Claim Number',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,
        pinned: 'left',
        cellRenderer,
    },
    {
        field: 'claimStatusCode',
        headerName: 'Status',
        sortable: true,
        filter: true,
        width: 90,
    },
    {
        field: 'lastUpdatedDate',
        headerName: 'Last Updated',
        sortable: true,
        filter: true,
        width: 120,
        valueFormatter: data => data.value ? moment( data.value * 1000 ).utc().format( 'MM/DD/YYYY' ) : '',
    },
    {
        field: 'branchId',
        headerName: 'Branch',
        sortable: true,
        filter: true,
        width: 80,
    },
    {
        field: 'part.partNumber',
        headerName: 'Part Number',
        sortable: true,
        filter: true,
        width: 120,
    },
    {
        field: 'processDate',
        headerName: 'Process Date',
        sortable: true,
        filter: true,
        width: 120,
        valueFormatter: data => data.value ? moment( data.value * 1000 ).utc().format( 'MM/DD/YYYY' ) : '',
    },
    {
        field: 'buildDate',
        headerName: 'Build Date',
        sortable: true,
        filter: true,
        width: 120,
        valueFormatter: data => data.value ? moment( data.value * 1000 ).utc().format( 'MM/DD/YYYY' ) : '',
    },
    {
        field: 'pin.digit13',
        headerName: 'PIN',
        sortable: true,
        filter: true,
        width: 120,
    },
    {
        field: 'pin.digit17',
        headerName: 'PIN 17',
        sortable: true,
        filter: true,
        width: 120,
    },
    {
        field: 'language',
        headerName: 'Language',
        sortable: true,
        filter: true,
        minWidth: 90,
        tooltip: data => data.value,
    },
    {
        field: 'complaint',
        headerName: 'Complaint',
        sortable: true,
        filter: true,
        maxWidth: 150,
        tooltip: data => data.value,
    },
    {
        field: 'cause',
        headerName: 'Cause',
        sortable: true,
        filter: true,
        maxWidth: 150,
        tooltip: data => data.value,
    },
    {
        field: 'correction',
        headerName: 'Correction',
        sortable: true,
        filter: true,
        maxWidth: 150,
        tooltip: data => data.value,
    },

];
export default ShortClaimTableColumnDefinitions;
